import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "assets/theme/admin_form.css";

const AddScheme = () => {
  const navigate = useNavigate();
  const initialState = {
    scheme_title: "",
    scheme_type: "",
    launch_date: "",
    end_date: "",
    benefits: "",
    description: "",
    details: "",
    document_name: "",
    document: null,
  };

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "document") {
      const file = files[0];
      setFormData({ ...formData, document: file });

      if (file && file.type.startsWith("image")) {
        setPreview(URL.createObjectURL(file));
      } else {
        setPreview(null);
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.scheme_title.trim()) {
      newErrors.scheme_title = "योजना शीर्षक आवश्यक आहे (Scheme Title is required)";
    }
    if (!formData.scheme_type) {
      newErrors.scheme_type = "योजना प्रकार निवडा (Scheme Type is required)";
    }
    if (!formData.launch_date) {
      newErrors.launch_date = "प्रारंभ दिनांक आवश्यक आहे (Launch Date is required)";
    }
    if (!formData.end_date) {
      newErrors.end_date = "समाप्ती दिनांक आवश्यक आहे (End Date is required)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null) {
          data.append(key, formData[key]);
        }
      });

      await apiFetch("leader_admin/add_scheme", {
        method: "POST",
        body: data,
      });

      alert("Scheme Added Successfully");
      navigate("/scheme_list");
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>
        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                📜 नवीन योजना जोडा (Add Government Scheme)
              </h4>
              <small className="text-white-50">Register a new government scheme</small>
            </div>
          </div>

          <Link to="/scheme_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Scheme List
          </Link>
        </div>

        {/* Form Card */}
        <div className="card border-0 shadow-lg rounded-4">
          <div className="card-body p-4">
            <form onSubmit={handleSubmit} noValidate>
              <div className="row g-4">
                {/* Scheme Title */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    योजना शीर्षक / Scheme Title <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control shadow-sm ${errors.scheme_title ? "is-invalid" : ""}`}
                    name="scheme_title"
                    value={formData.scheme_title}
                    onChange={handleChange}
                  />
                  {errors.scheme_title && (
                    <small className="text-danger d-block mt-1">{errors.scheme_title}</small>
                  )}
                </div>

                {/* Scheme Type */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    योजना प्रकार / Scheme Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select shadow-sm ${errors.scheme_type ? "is-invalid" : ""}`}
                    name="scheme_type"
                    value={formData.scheme_type}
                    onChange={handleChange}
                  >
                    <option value="">निवडा / Select</option>
                    <option>केंद्र शासन / Central Government</option>
                    <option>राज्य शासन / State Government</option>
                    <option>महानगरपालिका / Municipal</option>
                    <option>स्थानिक संस्था / Local Body</option>
                  </select>
                  {errors.scheme_type && (
                    <small className="text-danger d-block mt-1">{errors.scheme_type}</small>
                  )}
                </div>

                {/* Launch Date */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    प्रारंभ दिनांक / Launch Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className={`form-control shadow-sm ${errors.launch_date ? "is-invalid" : ""}`}
                    name="launch_date"
                    value={formData.launch_date}
                    onChange={handleChange}
                  />
                  {errors.launch_date && (
                    <small className="text-danger d-block mt-1">{errors.launch_date}</small>
                  )}
                </div>

                {/* End Date */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    समाप्ती दिनांक / End Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className={`form-control shadow-sm ${errors.end_date ? "is-invalid" : ""}`}
                    name="end_date"
                    value={formData.end_date}
                    onChange={handleChange}
                  />
                  {errors.end_date && (
                    <small className="text-danger d-block mt-1">{errors.end_date}</small>
                  )}
                </div>

                {/* Description */}
                <div className="col-12">
                  <label className="form-label fw-semibold">वर्णन / Description</label>
                  <textarea
                    className="form-control shadow-sm"
                    rows="3"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>

                {/* Upload Document */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    दस्तऐवज / प्रतिमा अपलोड करा (ऐच्छिक) / Upload Document or Image (Optional)
                  </label>
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    name="document"
                    onChange={handleChange}
                    accept=".pdf,.doc,.docx,image/*"
                  />
                </div>

                {/* Image Preview */}
                {preview && (
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      प्रतिमा पूर्वावलोकन / Image Preview
                    </label>
                    <div className="border rounded-3 p-2 shadow-sm">
                      <img src={preview} alt="Preview" className="img-fluid rounded-3" />
                    </div>
                  </div>
                )}
              </div>

              {/* Submit Button */}
              <div className="d-flex justify-content-end mt-4 pt-3 border-top">
                <button
                  type="submit"
                  className="btn btn-success px-5 py-2 fw-semibold"
                  style={{ fontSize: "0.85rem" }}
                  disabled={loading}
                >
                  {loading ? "जतन करत आहे..." : "योजना जतन करा / Save Scheme"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AddScheme;